import { Pipe, PipeTransform } from '@angular/core';
import { PaymentStatus } from '../../interfaces/payment';

@Pipe({
  name: 'paymentStatus'
})
export class PaymentStatusPipe implements PipeTransform {

  transform(value: PaymentStatus): string {
    switch (value) {
      case PaymentStatus.PENDING_SOLICITATION:
        return 'Aguardando aceitação';
      case PaymentStatus.REJECTED_SOLICITATION:
        return 'Rejeitado';
      case PaymentStatus.PENDING_APPROVAL:
        return 'Aguardando aprovação';
      case PaymentStatus.PENDING_PAYMENT:
        return 'Aguardando pagamento';
      case PaymentStatus.PAID:
        return 'Pago';
      case PaymentStatus.CANCELED:
        return 'Cancelado';
      case PaymentStatus.PROCESSING_PAYMENT:
        return 'Processando pagamento';
      default:
        return '---';
    }
  }

}
